import { Box, styled } from "@mui/material";

export const FROSTED_GLASS = {
  backgroundColor: "rgba(216, 216, 216, 0.4)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
} as const;

export const CenterPanelContainer = styled(Box, {
  label: "CenterPanelContainer",
})({
  width: "100%",
  height: "100%",
  flexShrink: 0,
  position: "relative",
});
